// import React, { useState } from "react"
// import '../styles/user_management_styles.css'
// import Navbar from "./Navbar.js"
// import 'bootstrap/dist/css/bootstrap.min.css';
// import RoleTable from "./tables/RoleTable";
// import Cookies from "universal-cookie";

// const PermissionDelete = () => {
//     const [selectedRole, setSelectedRole] = useState([]);
//     const cookies = new Cookies();
//     let actionInitiatingUser = -1;
//     try {
//         actionInitiatingUser = parseInt(cookies.get('userID'));
//     } catch (error) {}

//     return (
//         <div className="Reports">
//             <link href="https://fonts.googleapis.com/icon?family=Material+Icons"
//                 rel="stylesheet" />
//             <script src='bootstrap/dist/js/bootstrap.min.js'></script>
//             <Navbar />
//             <main className="container-fluid">
//                 <section className="d-flex row justify-content-center" style={{ padding: "1vw" }}>
//                     <header className="h1 text-center">Delete Role and Permissions</header>
//                     <div>
//                         <RoleTable selectedRole={selectedRole} setSelectedRole={setSelectedRole} deleteButton={true} editButton={false} actionInitiatingUser = {actionInitiatingUser} />
//                     </div>
//                 </section>
//             </main>
//         </div >
//     );
// }

// export default PermissionDelete;

import React, { useState } from "react";
import "../styles/user_management_styles.css";
import Navbar from "./Navbar.js";
import "bootstrap/dist/css/bootstrap.min.css";
import RoleTable from "./tables/RoleTable";
import Cookies from "universal-cookie";
import { Box, Typography, Card, Container, Grid } from "@mui/material";
import { Trash2 } from "lucide-react";

const PermissionDelete = () => {
  const [selectedRole, setSelectedRole] = useState([]);
  const cookies = new Cookies();
  let actionInitiatingUser = -1;

  try {
    actionInitiatingUser = parseInt(cookies.get("userID"));
  } catch (error) {}

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#0f1729", color: "white" }}>
      {/* Google Fonts & Scripts (Consider moving these to index.html for production) */}
      <link
        href="https://fonts.googleapis.com/icon?family=Material+Icons"
        rel="stylesheet"
      />

      <Navbar />

      <Box component="main" sx={{ py: 12, maxWidth: "1400px", mx: "auto" }}>
        <Box sx={{ mb: 4 }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              color: "white",
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            Delete Role and Permissions
          </Typography>
          <Typography
            sx={{
              fontSize: "1.1rem",
              color: "rgba(255,255,255,0.7)",
              mt: 0.5,
            }}
          >
            Carefully review and remove roles from the system.
          </Typography>
        </Box>

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card
              sx={{
                background: "rgba(15, 23, 42, 0.6)",
                backdropFilter: "blur(12px)",
                WebkitBackdropFilter: "blur(12px)",
                color: "white",
                borderRadius: "16px",
                border: "1px solid rgba(148, 163, 184, 0.15)",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.5)",
                p: 3,
              }}
            >
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mb: 3 }}
              >
                <Trash2 size={24} color="#ef4444" />
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  Role Selection
                </Typography>
              </Box>

              <RoleTable
                selectedRole={selectedRole}
                setSelectedRole={setSelectedRole}
                deleteButton={true}
                editButton={false}
                actionInitiatingUser={actionInitiatingUser}
              />
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default PermissionDelete;
